/*
  Unified Fields Props Definition
*/
import {FormattedMessage} from "react-intl"
import React from "react"

export default {
	load() {
		return {
			fields: {
				type: {
					label: <FormattedMessage id="Patient.form.patientrecord.diagnosistype" />,
					rules: "required"
				},
				name: {
					label: <FormattedMessage id="Common.label.name" />,
					rules: "required|string"
				},
				from: {
					label: <FormattedMessage id="Common.label.from" />,
					rules: "required",
					type: "date"
				},
				to: {
					label: <FormattedMessage id="Common.label.to" />,
					type: "date"
				}
			}
		}
	}
}
